import { render, staticRenderFns } from "./BaseModalExportarArquivo.vue?vue&type=template&id=c776be4a&lang=pug"
import script from "./BaseModalExportarArquivo.vue?vue&type=script&lang=js"
export * from "./BaseModalExportarArquivo.vue?vue&type=script&lang=js"
import style0 from "./BaseModalExportarArquivo.vue?vue&type=style&index=0&id=c776be4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports